var _defs, _defs2, _path, _defs3, _path2, _defs4, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmissionTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -18.6631 414.9355)",
    style: {
      fill: "#BDE5FF"
    },
    cx: 491.54,
    cy: 229.996,
    rx: 202.142,
    ry: 202.142
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 750 500)",
    width: 750,
    height: 500
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011751713259145749970000010974517486994088367_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000011751713259145749970000010974517486994088367_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 711.78,
    y: 331.424,
    transform: "matrix(0.8335 0.5525 -0.5525 0.8335 305.6413 -344.7123)",
    style: {
      fill: "#FBDDB6"
    },
    width: 25.987,
    height: 6.691
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.591,
    y: 76.961,
    transform: "matrix(-0.866 0.5 -0.5 -0.866 1308.2755 -189.9397)",
    style: {
      fill: "#B1EBC9"
    },
    width: 25.987,
    height: 6.691
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.767,
    y: 49.835,
    transform: "matrix(0.9642 0.2653 -0.2653 0.9642 25.4255 -81.8692)",
    style: {
      fill: "#FFA5E0"
    },
    width: 25.987,
    height: 6.691
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.737,
    y: 379.917,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 361.433 -106.0507)",
    style: {
      fill: "#FFEE92"
    },
    width: 25.987,
    height: 6.691
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.86,
    y: 198.891,
    transform: "matrix(-0.9295 -0.3689 0.3689 -0.9295 170.1635 437.0036)",
    style: {
      fill: "#95E3B5"
    },
    width: 25.987,
    height: 6.691
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.672,
    y: 386.13,
    transform: "matrix(0.866 -0.5 0.5 0.866 -190.7635 67.0125)",
    style: {
      fill: "#6BBAFF"
    },
    width: 25.987,
    height: 6.691
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5C2"
    },
    d: "M771.856,216.328l-70.989,75.661l-30.029-99.308L771.856,216.328z M708.126,260.978 l33.243-35.431l-47.305-11.074L708.126,260.978z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#A9DDFF",
      strokeWidth: 2.6803,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "8.0408,9.3809"
    },
    d: " M-46.408,335.683c-48.44-5.81-119.21,23.735-109.682,77.514c2.757,15.56,15.913,27.439,30.178,32.349 c14.265,4.909,29.845,3.652,44.44-0.02c14.595-3.672,28.565-9.659,42.928-14.237c47.901-15.266,100.302-14.356,147.702,2.565 c16.941,6.048,33.585,14.326,46.356,27.542c12.772,13.216,21.248,32.023,19.286,50.79"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B1EBC9",
      strokeWidth: 3.1607,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "9.4823,11.0626"
    },
    d: " M-109.992,134.178c14.502,21.786,37.271,37.197,58.645,43.836c21.374,6.639,41.578,5.481,60.109,1.694 c51.848-10.595,93.947-41.822,118.663-88.021c7.411-13.853,13.306-29.01,21.675-42.012c8.368-13.002,19.579-23.963,35.026-27.351 c15.447-3.389,35.981,1.548,51.462,16.915c53.507,53.115,29.589,151.895-27.163,133.316 C132.289,147.631,309.008-30.585,466.158-11.418"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFEE92",
      strokeWidth: 2.6803,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "8.0408,9.3809"
    },
    d: " M813.825,153.969c-24.29,15.387-52.077,26.286-80.822,26.987c-28.745,0.701-58.445-9.707-77.484-31.253 c-19.04-21.546-25.432-54.711-12.182-80.229c6.307-12.147,17.539-22.545,31.111-24.31c20.986-2.729,40.476,18.204,39.397,39.339 c-1.079,21.135-19.315,39.032-40.032,43.354c-20.717,4.322-42.672-3.216-59.241-16.383 c-16.568-13.166-28.362-31.434-37.742-50.404c-18.973-38.372-29.229-81.834-23.974-124.316"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.076,
    y: 207.06,
    transform: "matrix(0.866 0.5 -0.5 0.866 145.2781 -82.1925)",
    style: {
      fill: "#FBDDB6"
    },
    width: 45.873,
    height: 45.873
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B1EBC9"
    },
    d: "M178.859,131.039L14.276,72.695l132.819-113.36L178.859,131.039z M66.986,62.943l77.072,27.322 L129.184,9.859L66.986,62.943z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5EEFF"
    },
    d: "M689.277,17.39c10.194,19.643,34.381,27.303,54.024,17.11 c19.643-10.194,27.303-34.381,17.11-54.024L689.277,17.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD1EF"
    },
    d: "M-52.374,331.438c37.641,34.831,96.391,32.553,131.222-5.087 c34.831-37.641,32.554-96.391-5.087-131.222L-52.374,331.438z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708.067,
    y: 428.746,
    transform: "matrix(0.3809 0.9246 -0.9246 0.3809 909.5384 -404.0428)",
    style: {
      fill: "#FFD1EF"
    },
    width: 96.826,
    height: 96.826
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27AA5"
    },
    d: "M594.631,370.453l-12.444-83.7l-27.723-103.09c78.835-5.385,108.727,29.194,123.09,111.743 c7.192,41.337,18.961,100.394,18.961,100.394C673.035,411.047,611.859,387.951,594.631,370.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27AA5"
    },
    d: "M412.124,198.58c-21.822,4.058-84.67,4.928-95.585,66.613 c-6.821,38.546,33.409,174.115,33.409,174.115l61.402-29.029c15.075-34.235,27.654-66.857,40.837-102.135L412.124,198.58z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000137119369487183878140000009318154713356401053_",
    style: {
      fill: "#2A292B"
    },
    points: "443.171,213.735  496.648,182.774 540.363,188.264 561.68,188.719 628.922,476.981 425.507,474.53  "
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000078746149530061937380000008045775812117491107_",
    points: "489.746,212.612 618.471,214.471  682.655,477.159 546.446,477.159  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000078746149530061937380000008045775812117491107_",
    style: {
      overflow: "visible",
      fill: "#E27AA5"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000121980262762837258370000002003217006571396272_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000078746149530061937380000008045775812117491107_",
    style: {
      overflow: "visible"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M586.201,183.909c0,0,20.339,132.872-112.85,142.724c-47.978,3.549-89.378-44.312-89.378-44.312L586.201,183.909z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000067198710270758747570000015488079029610679216_",
    points: "352.671,242.02 453.235,245.236  494.02,475.43 374.659,476.981  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000067198710270758747570000015488079029610679216_",
    style: {
      overflow: "visible",
      fill: "#E27AA5"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000070091338601606675020000000644534286558826931_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000067198710270758747570000015488079029610679216_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M451.204,205.197c-86.141-20.558-58.974-161.121,26.545-149.487 c51.409,6.994,74.092,52.717,61.261,109.825C532.276,195.51,501.059,212.998,451.204,205.197z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000022526404061365965800000013269718654852457404_",
    d: "M448.988,252.327 c-41.855-2.008-43.149-36.325-43.149-36.325l4.873-48.948l89.489,13.051l-6.725,41.483 C493.476,221.588,490.843,254.335,448.988,252.327z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9A898"
    },
    d: "M444.726,210.053L444.726,210.053c-26.935-3.897-45.611-28.89-41.714-55.824l3.079-21.283 c2.714-18.76,19.919-45.632,55.824-41.714h0c26.934,3.896,45.61,28.89,41.714,55.824l-3.079,21.283 C496.653,195.273,471.66,213.949,444.726,210.053z"
  }), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000085221507557872271880000018221045230131377062_",
    d: "M444.726,210.053L444.726,210.053 c-26.935-3.897-45.611-28.89-41.714-55.824l3.079-21.283c2.737-18.918,15.881-33.761,32.795-39.572 c7.168-2.462,15.013-3.302,23.029-2.143h0c26.934,3.896,45.61,28.89,41.714,55.824l-3.079,21.283 C496.653,195.273,471.66,213.949,444.726,210.053z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061451635255675934530000009972570079031004077_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085221507557872271880000018221045230131377062_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      clipPath: "url(#SVGID_00000061451635255675934530000009972570079031004077_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27AA5"
    },
    d: "M425.214,165.598c-1.96,7.675-9.771,12.307-17.446,10.347 c-7.675-1.96-12.307-9.771-10.347-17.446c1.96-7.674,9.771-12.307,17.446-10.347 C422.542,150.113,427.175,157.924,425.214,165.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27AA5"
    },
    d: "M491.112,177.567c-1.961,7.674-9.771,12.307-17.446,10.346 c-7.674-1.96-12.307-9.771-10.347-17.445c1.961-7.675,9.772-12.307,17.446-10.347 C488.44,162.081,493.072,169.892,491.112,177.567z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M445.366,145.042 c0.395,2.016,0.79,4.099,0.361,6.107c-0.429,2.009-1.902,3.943-3.933,4.249c-1.044,0.157-2.196-0.104-3.104,0.433 c-1.109,0.656-1.305,2.271-0.77,3.444c0.536,1.173,1.597,2.004,2.621,2.789"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M488.865,137.567 c-2.573-5.193-13.796-11.154-25.099-5.685"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M409.914,124.387 c4.015-4.18,16.511-6.489,25.646,2.125"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M459.404,164.618 c-9.042,9.492-18.032,9.713-26.983,3.31"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M438.477,145.684c0.139-5.391-7.555-10.072-17.172-11.597 c-9.616-1.525-17.514,0.918-17.652,6.075c-0.149,5.591,6.416,10.199,17.159,11.764 C429.853,153.242,438.313,152.084,438.477,145.684z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M429.147,147.582c-0.121,4.63-3.972,8.284-8.602,8.163s-8.284-3.972-8.163-8.602 c0.121-4.629,3.972-8.284,8.602-8.163C425.613,139.101,429.268,142.952,429.147,147.582z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M490.763,154.313c0.139-5.391-7.555-10.072-17.172-11.597 c-9.616-1.525-17.514,0.918-17.652,6.075c-0.149,5.591,6.416,10.199,17.159,11.764 C482.139,161.871,490.599,160.712,490.763,154.313z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M480.534,154.593c-0.121,4.63-3.972,8.284-8.602,8.163c-4.629-0.121-8.284-3.972-8.163-8.602 c0.121-4.629,3.972-8.284,8.602-8.163C477,146.113,480.655,149.964,480.534,154.593z"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M425.507,100.42c24.624-0.587,52.659,4.462,71.378,13.847c-2.443-4.356-20.085-26.07-37.908-27.415 C445.423,85.831,425.507,100.42,425.507,100.42z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M398.59,137.195c-11.583,89.865-22.66,62.88-38.108,71.231 c-30.469,16.47,35.341,207.663,35.341,207.663l56.709-117.885c0,0-34.051-74.574-44.14-113.566 C397.751,143.516,398.59,137.195,398.59,137.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M539.01,165.534c0.771-2.512-31.467,16.741-33.366,14.925c-1.504-1.439-3.646-1.941-5.68-2.382 c-0.582-0.126-1.155-0.227-1.732-0.34c-7.671,21.727-33.117,46.419-56.788,42.995c-16.061-2.324-25.9-22.83-33.053-36.094 c-2.133-0.099-7.075-4.797-9.282-5.047c2.475,6.587,8.006,29.341,0.504,33.087c-33.508,156.877,200.023,134.514,186.588-28.77 c-12.139-2.003-28.991-0.344-39.202-2.507C539.792,179.874,535.837,175.868,539.01,165.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M403.259,150.71 c-6.017,23.811-3.876,90.826,23.246,114.109"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M405.068,175.402 c19.401,52.792,49.978,59.259,69.107,59.361"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M380.025,190.441 c-1.455,17.47-2.911,35.039-1.415,52.505c1.495,17.466,6.102,34.991,15.868,49.549c9.766,14.558,27.214,23.734,48.376,24.287"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M491.403,233.627 c13.992-3.511,26.41-10.822,32.828-23.741"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M501.796,162.744 c2.984-9.978,5.028-24.075,6.486-36.774c1.591-13.848-1.583-27.967-9.66-39.327c-3.002-4.223-6.563-7.905-10.633-9.885"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M406.09,132.945 c1.947-8.968,3.35-12.664,5.871-23.055c3.823-15.754,14.612-29.185,29.586-35.394c6.435-2.668,13.888-4.144,22.171-3.084"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M436.961,272.586 c13.825,5.815,51.899,7.744,89.113-36.448"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M445.31,220.123 c19.982-0.12,35.312-4.223,52.255-21.935c9.383-9.809,16.591-21.821,19.638-35.049"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    x1: 469.235,
    y1: 91.198,
    x2: 451.336,
    y2: 82.713
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    x1: 448.417,
    y1: 372.674,
    x2: 459.399,
    y2: 376.171
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    x1: 448.417,
    y1: 393.021,
    x2: 455.821,
    y2: 395.589
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9A898"
    },
    d: "M439.733,355.507l3.102-115.542c0.255-9.509-3.063-18.768-9.299-25.95l-24.54-28.261 c0,0,4.117-21.793,3.044-25.952c-1.62-6.283-11.608,8.322-11.608,8.322s6.607-20.137-0.015-20.794 c-2.681-0.266-15.662,21.944-15.662,21.944s13.134-25.781,10.859-29.622c-2.075-3.504-11.717,5.524-21.122,16.093 c3.971-6.984,7.211-13.701,5.043-13.801c-4.534-0.208-28.38,23.77-26.789,36.563c1.773,14.251,28.686,57.632,28.686,57.632 l-6.941,64.194L439.733,355.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M365.772,209.024 c7.592,14.109,15.661,27.114,15.661,27.114l-6.941,64.194l65.241,55.175l3.102-115.542c0.255-9.509-3.063-18.768-9.299-25.95 l-24.54-28.261c0,0,4.117-21.793,3.044-25.952c-1.62-6.283-11.608,8.322-11.608,8.322s6.607-20.137-0.015-20.794 c-0.67-0.066-1.984,1.272-3.578,3.316"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M367.581,201.413l-3.617-22.735 c-0.631-3.964,0.285-8.019,2.558-11.328l7.971-11.605"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M381.16,202.947l-2.511-18.112 c-0.36-2.598,0.156-5.242,1.466-7.514l4.64-8.047"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M400.433,168.123l-4.739,12.758 c-0.627,1.689-0.827,3.507-0.58,5.292l2.471,17.869"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    x1: 381.433,
    y1: 236.139,
    x2: 388.864,
    y2: 247.902
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27AA5"
    },
    d: "M474.431,264.38l-97.881-34.384c0,0-25.549,150.937-29.546,180.392 c-4.83,35.589,20.247,62.004,47.7,64.54c36.684,3.389,54.491-15.196,60.674-65.834 C462.982,346.822,474.431,264.38,474.431,264.38z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.948,
      strokeMiterlimit: 10
    },
    x1: 376.549,
    y1: 229.996,
    x2: 347.003,
    y2: 410.388
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.948,
      strokeMiterlimit: 10
    },
    d: "M474.431,264.218L453.795,421.13 c0,0-5.528,58.181-52.397,54.069"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E27AA5"
    },
    d: "M693.583,380.931l-98.952-10.477l-72.937,15.691l34.779,87.834l61.998-7.952 C688.51,459.199,707.831,436.593,693.583,380.931z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.652,
    y: 343.117,
    transform: "matrix(0.9596 0.2813 -0.2813 0.9596 130.6525 -118.713)",
    style: {
      fill: "#F4881D"
    },
    width: 12.475,
    height: 105.367
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2A292B",
      strokeWidth: 0.9754,
      strokeMiterlimit: 10
    },
    d: "M494.352,350.771l-28.194,96.198  M461.986,445.746l28.194-96.198"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.783,
    y: 337.936,
    transform: "matrix(0.9596 0.2813 -0.2813 0.9596 116.743 -125.0528)",
    style: {
      fill: "#6BBAFF"
    },
    width: 12.475,
    height: 12.475
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M501.034,342.421l-11.971-3.509l1.611-5.495c0.516-1.759,2.359-2.767,4.118-2.252l5.601,1.642 c1.759,0.516,2.767,2.359,2.251,4.118L501.034,342.421z"
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    points: "521.694,386.145  594.631,370.453 578.46,287.344  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9A898"
    },
    d: "M555.702,414.538c-10.161-18.44-24.655-27.87-34.008-28.394 c-17.93-1.005-53.815,16.62-60.307,22.047c-8.369,6.995-3.405,16.487-3.405,16.487c-7.066,5.933-6.559,19.052,2.509,19.534 c-6.451,3.405-6.156,12.675,0.127,15.245c-6.397,9.234,11.806,16.536,40.437,17.367c18.037,0.523,36.878-0.225,55.419-2.846 C566.14,462.582,565.252,431.87,555.702,414.538z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.948,
      strokeMiterlimit: 10
    },
    x1: 457.981,
    y1: 424.678,
    x2: 484.437,
    y2: 416.089
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.948,
      strokeMiterlimit: 10
    },
    x1: 460.49,
    y1: 444.212,
    x2: 486.027,
    y2: 439.308
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    x1: 627.659,
    y1: 364.349,
    x2: 594.631,
    y2: 370.453
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.8188,
      strokeMiterlimit: 10
    },
    d: "M556.473,473.978 c53.358-6.844,108.401-7.613,132.804-34.67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M265.723,457.544c0,1.354,0,2.708,0,4.062 c0,1.167,0,2.333,0,3.5c0,1.354,0,2.708,0,4.062c54.022-20.113,112.663-20.113,166.685,0c0-1.354,0-2.708,0-4.062 c0-1.167,0-2.333,0-3.5c0-1.354,0-2.708,0-4.062C378.385,437.431,319.745,437.431,265.723,457.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M432.435,457.544c0,1.354,0,2.708,0,4.062 c0,1.167,0,2.333,0,3.5c0,1.354,0,2.708,0,4.062c54.022-20.113,112.662-20.113,166.685,0c0-1.354,0-2.708,0-4.062 c0-1.167,0-2.333,0-3.5c0-1.354,0-2.708,0-4.062C545.097,437.431,486.457,437.431,432.435,457.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B73123"
    },
    d: "M432.419,475.43c-54.026-20.114-112.67-20.114-166.696,0c0-2.521,0-5.041,0-7.562 c54.026-20.114,112.67-20.114,166.696,0C432.419,470.389,432.419,472.91,432.419,475.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B73123"
    },
    d: "M432.423,475.43c54.026-20.114,112.67-20.114,166.696,0c0-2.521,0-5.041,0-7.562 c-54.026-20.114-112.67-20.114-166.696,0C432.423,470.389,432.423,472.91,432.423,475.43z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2346B5"
    },
    d: "M408.006,470.114H152.134c-2.551,0-4.62-2.068-4.62-4.62l0,0c0-2.551,2.068-4.62,4.62-4.62 h255.872c2.551,0,4.62,2.068,4.62,4.62l0,0C412.626,468.046,410.557,470.114,408.006,470.114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3656DD"
    },
    d: "M302.431,470.114H102.122c-2.797,0-5.258-1.845-6.043-4.529L49.245,305.48 c-1.179-4.031,1.843-8.064,6.043-8.064h200.308c2.797,0,5.258,1.845,6.043,4.529l46.834,160.105 C309.653,466.081,306.63,470.114,302.431,470.114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BBAFF"
    },
    d: "M294.173,470.114H93.865c-2.797,0-5.258-1.845-6.043-4.529L40.987,305.48 c-1.179-4.031,1.844-8.064,6.043-8.064h200.308c2.797,0,5.258,1.845,6.043,4.529l46.834,160.105 C301.395,466.081,298.373,470.114,294.173,470.114z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6769 -0.7361 0.7361 0.6769 -226.9919 249.4167)",
    style: {
      fill: "#A9DDFF"
    },
    cx: 170.602,
    cy: 383.263,
    rx: 26.123,
    ry: 34.751
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#261514"
    },
    d: "M712.873,480.747H37.127c-2.936,0-5.316-2.38-5.316-5.316l0,0c0-2.936,2.38-5.316,5.316-5.316 h675.746c2.936,0,5.316,2.38,5.316,5.316l0,0C718.189,478.366,715.809,480.747,712.873,480.747z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmissionTest);
export default __webpack_public_path__ + "static/media/admission-test.06f3338d8255b4e8fcd07c75a2713b91.svg";
export { ForwardRef as ReactComponent };